import { getDatabase } from "firebase/database";
import { signInAnonymously } from "firebase/auth";
import { app, auth } from "./firebase_config";

const DATABASE_URL = process.env.REACT_APP_FIREBASE_DATABASE_URL;

export const db = DATABASE_URL
  ? getDatabase(app, DATABASE_URL)
  : getDatabase(app);

export async function ensureAnonymousAuth(): Promise<void> {
  // If API key is missing, skip auth attempt; rely on public read rules
  const apiKeyAvailable = process.env.REACT_APP_FIREBASE_API_KEY !== undefined;
  if (!apiKeyAvailable) return Promise.resolve();

  // Check current auth state synchronously
  const currentUser = auth.currentUser;

  // If user is already signed in (either with Google or anonymously), don't do anything
  if (currentUser) {
    return Promise.resolve();
  }

  // Only sign in anonymously if there's no user at all
  // This prevents interfering with Google OAuth logout
  try {
    await signInAnonymously(auth);
  } catch {
    // Ignore; some rules allow public read
  }
}
